/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
//import VeeValidate from 'vee-validate';
Vue.use(Vuesax)
//Vue.use(VeeValidate);

// axios
import {init,setAuthorizationHeader} from "./axios.js"
window.restApi = setAuthorizationHeader(init());

// Theme Configurations
import '../themeConfig.js'

// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// ACL
//import acl from './acl/acl.js';


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

//lodash
import lodash from 'lodash';
import VueLodash from 'vue-lodash';
Vue.use(VueLodash, { name: 'custom' , lodash: lodash });


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

//const venom = require('venom-bot');

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

require('./assets/css/openimagehealth.css')
require('./assets/css/openimagehealth-responsive.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

Vue.filter('formatCurrency', function(value) {
  if (value) {
    let val = (value/1).toFixed(2).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
});

Vue.filter('formatKilo', function(value) {
  if (value) {
    let val = (value/1).toFixed().replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
});

// moment form
import moment from 'moment';

Vue.filter('formatDate', function(value) {
  if (value) {
    var xdate = new Date(value);
    return  moment(xdate).format('DD-MMM-YYYY');
  }
});

Vue.filter('formatDateTime', function(value) {
  if (value) {
    var xdate = new Date(value);
    return  moment(xdate).format('DD-MMM-YYYY HH:MM');
  }
});

Vue.filter('calcAge', function(value) {
  if (value) {
    var xdate = new Date(value);

    var a = moment(xdate);
    var b = moment();

    var years = b.diff(a, 'year');
    a.add(years, 'years');

    var months = b.diff(a, 'months');

    if (Number(months) > 0) {
      return years+ '.' + months;
    } else {
      return years;
    }
  }
});

Vue.filter('calcAge1', function(birthday) {
    let now = new Date();
    let today = new Date(now.getYear(),now.getMonth(),now.getDate());

    let yearNow = now.getYear();
    let monthNow = now.getMonth();
    let dateNow = now.getDate();

    let dob = new Date(birthday);

    let yearDob = dob.getYear();
    let monthDob = dob.getMonth();
    let dateDob = dob.getDate();
    let age = {};
    let ageString = "";
    let yearString = "";
    let monthString = "";
    let dayString = "";


    let yearAge = yearNow - yearDob;
      let monthAge = 0;
    let dateAge = 0;

    if (monthNow >= monthDob)
        monthAge = monthNow - monthDob;
    else {
        yearAge--;
        monthAge = 12 + monthNow -monthDob;
    }

    if (dateNow >= dateDob)
        dateAge = dateNow - dateDob;
    else {
        monthAge--;
        dateAge = 31 + dateNow - dateDob;

        if (monthAge < 0) {
            monthAge = 11;
            yearAge--;
        }
    }

    age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
    };

    if ( age.years > 1 ) yearString = " tahun";
    else yearString = " tahun";
    if ( age.months> 1 ) monthString = " bulan";
    else monthString = " bulan";
    if ( age.days > 1 ) dayString = " hari";
    else dayString = " hari";


    if ( (age.years > 0) && (age.months > 0) && (age.days > 0) )
        ageString = age.years + yearString + " " + age.months + monthString;
    else if ( (age.years == 0) && (age.months == 0) && (age.days > 0) )
        ageString = age.days + dayString;
    else if ( (age.years > 0) && (age.months == 0) && (age.days == 0) )
        ageString = age.years + yearString;
    else if ( (age.years > 0) && (age.months > 0) && (age.days == 0) )
        ageString = age.years + yearString + " " + age.months + monthString;
    else if ( (age.years == 0) && (age.months > 0) && (age.days > 0) )
        ageString = age.months + monthString + " " + age.days + dayString;
    else if ( (age.years > 0) && (age.months == 0) && (age.days > 0) )
        ageString = age.years + yearString + " " + age.days + dayString;
    else if ( (age.years == 0) && (age.months > 0) && (age.days == 0) )
        ageString = age.months + monthString;
    else ageString = "Oops! Could not calculate age!";

    return ageString;
});

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})
